<template>
  <button
    v-if="sidepanelDock.canDock.value"
    v-tooltip.bottom="label"
    type="button"
    :aria-label="label"
    class="flex items-center border-l border-gray-200 px-3 text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-700"
    @click="sidepanelDock.isExpanded.value = !sidepanelDock.isExpanded.value"
  >
    <Icon
      :name="
        sidepanelDock.isExpanded.value
          ? 'panel-right-close-lucide'
          : 'panel-right-open-lucide'
      "
      class="size-4.5"
    />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Icon from "@/components/Core/Icon.vue";
import { useShellDocks } from "@/composables/useShellDocks";

const { sidepanelDock } = useShellDocks();
const label = computed(() =>
  sidepanelDock.isExpanded.value ? "Collapse panel" : "Expand panel",
);
</script>
